import { render, staticRenderFns } from "./group-page.vue?vue&type=template&id=f0381f3e&scoped=true&"
import script from "./group-page.vue?vue&type=script&lang=js&"
export * from "./group-page.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f0381f3e",
  null
  
)

export default component.exports